import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-brand-sand rounded-t-[24px] sm:rounded-t-[40px] mt-6 lg:mt-8 mx-3 sm:mx-4 lg:mx-8">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 py-10 sm:py-12 lg:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-10 lg:gap-12 mb-10 lg:mb-12">
          <div>
            <h3 className="text-xl sm:text-2xl font-bold text-brand-navy mb-4 sm:mb-6">
              Your Florida Energy Partner
            </h3>
            <a
              href="#contact"
              className="inline-block bg-brand-red text-white px-6 py-3 rounded-full font-semibold hover:bg-brand-red-dark transition-all duration-300 whitespace-nowrap cursor-pointer text-sm sm:text-base"
            >
              Get Started
            </a>
          </div>

          <div>
            <h4 className="text-brand-navy font-semibold mb-3 sm:mb-4 text-base sm:text-lg">Services</h4>
            <ul className="space-y-2.5 sm:space-y-3">
              <li>
                <Link to="/services" className="text-gray-600 hover:text-brand-red transition-colors text-sm">
                  Solar Installation
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-600 hover:text-brand-red transition-colors text-sm">
                  HVAC Systems
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-600 hover:text-brand-red transition-colors text-sm">
                  Attic Insulation
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-600 hover:text-brand-red transition-colors text-sm">
                  Solar Attic Fans
                </Link>
              </li>
              <li>
                <Link to="/protection-plans" className="text-gray-600 hover:text-brand-red transition-colors text-sm">
                  Protection Plans
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-brand-navy font-semibold mb-3 sm:mb-4 text-base sm:text-lg">Company</h4>
            <ul className="space-y-2.5 sm:space-y-3">
              <li>
                <Link to="/testimonials" className="text-gray-600 hover:text-brand-red transition-colors text-sm">
                  Testimonials
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-gray-600 hover:text-brand-red transition-colors text-sm">
                  FAQ
                </Link>
              </li>
              <li>
                <a href="#rebates" className="text-gray-600 hover:text-brand-red transition-colors text-sm cursor-pointer">
                  Rebates &amp; Incentives
                </a>
              </li>
              <li>
                <Link to="/savings-calculator" className="text-gray-600 hover:text-brand-red transition-colors text-sm">
                  Savings Calculator
                </Link>
              </li>
              <li>
                <Link to="/service-areas" className="text-gray-600 hover:text-brand-red transition-colors text-sm">
                  Service Areas
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-brand-navy font-semibold mb-3 sm:mb-4 text-base sm:text-lg">Connect</h4>
            <ul className="space-y-2.5 sm:space-y-3 mb-5 sm:mb-6">
              <li>
                <a
                  href="https://instagram.com"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="text-gray-600 hover:text-brand-red transition-colors text-sm flex items-center gap-2"
                >
                  <i className="ri-instagram-line"></i>
                  Instagram
                </a>
              </li>
              <li>
                <a
                  href="https://facebook.com"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="text-gray-600 hover:text-brand-red transition-colors text-sm flex items-center gap-2"
                >
                  <i className="ri-facebook-line"></i>
                  Facebook
                </a>
              </li>
              <li>
                <a
                  href="https://youtube.com"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="text-gray-600 hover:text-brand-red transition-colors text-sm flex items-center gap-2"
                >
                  <i className="ri-youtube-line"></i>
                  YouTube
                </a>
              </li>
            </ul>
            <div>
              <p className="text-gray-500 text-sm mb-2">Subscribe for energy-saving tips</p>
              <div className="flex gap-2">
                <input
                  type="email"
                  placeholder="Your email"
                  className="flex-1 min-w-0 px-4 py-2 bg-white border border-gray-300 rounded-full text-gray-800 placeholder-gray-400 text-sm focus:outline-none focus:border-brand-red"
                />
                <button className="w-10 h-10 flex-shrink-0 flex items-center justify-center bg-brand-red rounded-full text-white hover:bg-brand-red-dark transition-colors cursor-pointer whitespace-nowrap">
                  <i className="ri-arrow-right-line"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-300 pt-6 sm:pt-8">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-gray-500 text-xs sm:text-sm text-center sm:text-left">
              &copy; 2025 United States Home Solutions. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
